<app-navbar [title]="pageTitle">
	<!-- <button class="btn btn-warning me-3" *ngIf="pageFunction=='edit' && !editable" (click)="deleteAsk()">Usuń</button> -->
	<button
		class="btn btn-primary me-3"
		*ngIf="(pageFunction === 'edit' && editable) || pageFunction === 'add'"
		(click)="submit()"
	>
		Zapisz
	</button>
	<button class="btn btn-primary me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="editUnlock()">
		Edycja
	</button>
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="container my-4">
	<form (submit)="submit()">
		<fieldset [disabled]="pageFunction !== 'add' && !editable">
			<legend>Dane podstawowe</legend>
			<div class="row">
				<div class="mb-3">
					<label class="custom-label">Imię i nazwisko</label>
					<ng-select
						class="custom-ng-select"
						(change)="onChange($event)"
						id="lastFirstName"
						name="lastFirstName"
						[multiple]="false"
						[(ngModel)]="personId"
					>
						<ng-option *ngFor="let item of employerList" [value]="item.id">
							{{ item.lastFirstName }}
						</ng-option>
					</ng-select>
				</div>
				<div class="col-sm-6">
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							id="givenName"
							name="givenName"
							[(ngModel)]="data.givenName"
							required
						/>
						<label class="required" for="firstName">Imię</label>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							id="familyName"
							name="familyName"
							[(ngModel)]="data.familyName"
							required
						/>
						<label class="required" for="familyName">Nazwisko</label>
					</div>
				</div>
				<legend>Dane kontaktowe</legend>
				<div class="row">
					<div class="form-floating mb-3">
						<input
							type="email"
							class="form-control"
							id="mailWork"
							name="mailWork"
							[(ngModel)]="data.mailWork"
						/>
						<label for="mailWork">E-mail służbowy</label>
					</div>
				</div>
				<div class="row">
					<div class="form-floating mb-3">
						<input
							type="email"
							class="form-control"
							id="mailPrivate"
							name="mailPrivate"
							[(ngModel)]="data.mailPrivate"
						/>
						<label for="mailPrivate">E-mail prywatny</label>
					</div>
				</div>
				<div class="row">
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							id="numberWork"
							name="numberWork"
							[(ngModel)]="data.numberWork"
						/>
						<label for="numberWork">Telefon służbowy</label>
					</div>
				</div>
				<div class="row">
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							id="numberPrivate"
							name="numberPrivate"
							[(ngModel)]="data.numberPrivate"
						/>
						<label for="numberPrivate">Telefon prywatny</label>
					</div>
				</div>
				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<legend>Pozostałe</legend>
					<div class="form-floating mb-3">
						<input
							type="date"
							class="form-control"
							id="birthday"
							name="birthday"
							[(ngModel)]="data.birthday"
							[disabled]="!editable"
						/>
						<label for="birthday">Urodziny</label>
					</div>
					<div class="mb-3">
						<label class="custom-label"><small class="text-danger mx-2">*</small>Typ</label>
						<ng-select
							class="custom-ng-select"
							id="occupation"
							name="occupation"
							[(ngModel)]="data.occupation"
							[disabled]="!editable"
						>
							<ng-option *ngFor="let item of occupationTypes" [value]="item.name">
								{{ item.name }}
							</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label class="custom-label" for="stanowisko"
							><small class="text-danger mx-2">*</small>Status</label
						>
						<ng-select
							class="custom-ng-select"
							id="status"
							name="status"
							[(ngModel)]="data.status"
							[disabled]="!editable"
							required
						>
							<ng-option *ngFor="let item of statuses" [value]="item.id">
								{{ item.name }}
							</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label class="custom-label" for="stanowisko">Stanowisko</label>
						<ng-select
							class="custom-ng-select"
							id="departaments"
							name="departaments"
							[(ngModel)]="data.organizationJob"
							[disabled]="!editable"
						>
							<ng-option *ngFor="let item of departaments" [value]="item.name">
								{{ item.name }}
							</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label class="custom-label" for="workPlace">Miejsce pracy</label>
						<ng-select
							class="custom-ng-select"
							[disabled]="!editable"
							id="workPlace"
							name="workPlace"
							[(ngModel)]="data.workPlace"
							[multiple]="false"
						>
							<ng-option *ngFor="let item of workPlace" [value]="item.name">
								{{ item.name }}
							</ng-option>
						</ng-select>
					</div>
				</fieldset>
			</div>
		</fieldset>
	</form>
</div>
